import { UserInfo } from "../../modules/auth";
import { SupportModal } from "../../modules/support";
import { SystemState } from "../../modules/system";
import { HeaderTitle } from "../HeaderTitle";
import styles from "./LMHeader.module.css";

export const LMHeader = () => {
  return (
    <>
      <div className={styles.left}>
        <HeaderTitle />
      </div>
      <div className={styles.right}>
        <SystemState />
        <UserInfo />
      </div>
      <SupportModal />
    </>
  );
};
